import { useAuth0 } from "@auth0/auth0-react"
import { useCallback, useState } from "react"

export const usePostData = () => {
	const [isLoading, setIsLoading] = useState(false)

	const { getAccessTokenSilently } = useAuth0()

	const postItem = useCallback(
		async (url, data, refreshData) => {
			setIsLoading(true)

			return fetch(
				new Request(process.env.REACT_APP_SESSION_ADDR + url, {
					method: "POST",
					headers: new Headers({
						"authorization": "Bearer " + (await getAccessTokenSilently()),
						"Content-Type": "application/json"
					}),
					body: JSON.stringify(data)
				})
			)
				.then((response) => {
					if (response.ok) {
						console.log("Posted Item successfully!")
						return response
					} else {
						// Check for response body and handle errors
						return response.text().then((text) => {
							let data = {}
							if (text) {
								try {
									data = JSON.parse(text)
								} catch {
									console.warn("Invalid JSON body")
								}
							}

							const errorMessage = data.message || response.statusText || "Something went wrong"
							throw new Error(errorMessage)
						})
					}
				})
				.then(() => {
					if (refreshData) {
						refreshData()
					}
				})
				.finally(() => {
					setIsLoading(false)
				})
		},
		[getAccessTokenSilently]
	)

	return { isLoading, postItem }
}
